import apiClient from './api-client';

const profissionaisService = {
    listar: async () => {
        try {
          const response = await apiClient.get('/profissionais');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      obter: async (id) => {
        try {
          const response = await apiClient.get(`/profissionais/${id}`);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      inserir: async (data) => {
        try {
          const response = await apiClient.post('/profissionais', data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.Message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      atualizar: async (id, data) => {
        try {
          const response = await apiClient.patch(`/profissionais/${id}`, data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.Message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      }
}

export default profissionaisService;